import React from 'react';
import './SyllabusSection.css';
import C2wCompleteSyllabus from '../../../c2wHomePage/coursesDetails/completeSyllabus/completeSyllabus';
import { motion } from 'framer-motion';

import syllabusData from '../../../../data/javaSyllabus.json';

const SyllabusSection = () => {
  // Construct the courseData prop format that C2wCompleteSyllabus expects
  const formattedCourseData = {
    courseTitle: "Java 2026",
    syllabusContentCountArray: [
      { count: "45", heading: "Lectures" },
      { count: "1000+", heading: "Class Codes" },
      { count: "1000+", heading: "MCQ Quiz" },
      { count: "45 Days", heading: "Total Length" }
    ],
    topicTitlesArray: syllabusData
  };

  // Stats data for the animated cards
  const stats = [
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="16 18 22 12 16 6" />
          <polyline points="8 6 2 12 8 18" />
        </svg>
      ),
      value: "1000+",
      label: "Class Codes"
    },
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
          <rect x="8" y="2" width="8" height="4" rx="1" ry="1" />
          <path d="M9 14l2 2 4-4" />
        </svg>
      ),
      value: "1000+",
      label: "Quizzes"
    },
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="4 17 10 11 4 5" />
          <line x1="12" y1="19" x2="20" y2="19" />
        </svg>
      ),
      value: "200+",
      label: "Practical Questions"
    },
    {
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A5 5 0 0 0 8 8c0 1 .3 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5" />
          <line x1="9" y1="18" x2="15" y2="18" />
          <line x1="10" y1="22" x2="14" y2="22" />
        </svg>
      ),
      value: "500+",
      label: "Logic Building Questions"
    }
  ];

  // Framer Motion Animation Variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.12
      }
    }
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 30, scale: 0.95 },
    visible: { 
      opacity: 1, 
      y: 0,
      scale: 1,
      transition: {
        type: "spring",
        stiffness: 90,
        damping: 14
      }
    }
  };

  return (
    <section className="ucp-syllabus-dashboard-container" style={{ paddingBottom: '100px' }}>
      <div className="ucp-section-header" style={{ marginBottom: '1.5rem' }}>
        <h2>Course Syllabus</h2>
        <p>Comprehensive curriculum designed for mastery. Select a module to explore.</p>
      </div>

      {/* Animated Stats Cards */}
      <motion.div 
        className="ucp-syllabus-stats-container"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-50px" }}
      >
        {stats.map((stat, index) => (
          <motion.div 
            key={index} 
            className="ucp-stat-capsule"
            variants={cardVariants}
          >
            <div className="ucp-stat-icon">{stat.icon}</div>
            <div className="ucp-stat-info">
              <span className="ucp-stat-value">{stat.value}</span>
              <span className="ucp-stat-label">{stat.label}</span>
            </div>
            <div className="ucp-stat-glow"></div>
          </motion.div>
        ))}
      </motion.div>

      {/* 
        We use the exact UI from C2wCompleteSyllabus. 
        It has its own heading which we will hide via CSS to prevent duplicate headings. 
      */}
      <div className="ucp-complete-syllabus-wrapper">
        <C2wCompleteSyllabus type='Online' courseData={formattedCourseData} />
      </div>
    </section>
  );
};

export default SyllabusSection;
